import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { IPcr } from '../../pcr/store/pcr.types'
import { FluidsConstants } from '../store/fluids.constants'
import { IFluidsState } from '../store/fluids.types'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { getFluidsSelector } from '../selectors'

export function* saveFluids() {
  const fluids: IFluidsState = yield select(getFluidsSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    const pcrDocUpdated: IPcr = {
      ...pcrDoc,
      fluids,
    }
    try {
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    } catch (e) {
      yield put(throwPcrException(`saveFluids() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* saveFluidsSaga() {
  yield takeLatest(
    [
      FluidsConstants.SAVE_FLUIDS,
      FluidsConstants.SET_TRANSPORT_TYPE,
      FluidsConstants.SET_BEFORE_INTAKE_CRYS,
      FluidsConstants.SET_BEFORE_INTAKE_COLL,
      FluidsConstants.SET_BEFORE_INTAKE_OTHER,
      FluidsConstants.SET_BEFORE_INTAKE_CUSTOM,
      FluidsConstants.SET_BEFORE_INTAKE_FEEDINGS,
      FluidsConstants.SET_BEFORE_OUTPUT_EBL,
      FluidsConstants.SET_BEFORE_OUTPUT_UO,
      FluidsConstants.SET_BEFORE_OUTPUT_OTHER,
      FluidsConstants.SET_BEFORE_OUTPUT_CUSTOM,
      FluidsConstants.SET_BEFORE_OUTPUT_BM,
      FluidsConstants.SET_DURING_INTAKE_CRYS,
      FluidsConstants.SET_DURING_INTAKE_COLL,
      FluidsConstants.SET_DURING_INTAKE_OTHER,
      FluidsConstants.SET_DURING_INTAKE_CUSTOM,
      FluidsConstants.SET_DURING_INTAKE_FEEDINGS,
      FluidsConstants.SET_DURING_OUTPUT_EBL,
      FluidsConstants.SET_DURING_OUTPUT_UO,
      FluidsConstants.SET_DURING_OUTPUT_OTHER,
      FluidsConstants.SET_DURING_OUTPUT_CUSTOM,
      FluidsConstants.SET_DURING_OUTPUT_BM,
      FluidsConstants.SET_CUSTOM_FLUID_VALUE,
    ],
    performWithMutexHOG,
    saveFluids
  )
}
